import { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { Typography } from '@mui/material';

import FilterListIcon from '@mui/icons-material/FilterList';

import CustomerReelTypesFilterStatus from './CustomerReelTypesFilterStatus';
import CustomerReelTypesFilterMaterialList from './CustomerReelTypesFilterMaterialList';

import { useSessionContext } from '../../../contexts/SessionContext';

export default function CustomerReelTypesFilter(props){
    //console.debug("RTS Break CustomerReelTypesFilter");

    const {setCurFilter, sessionCustomer} = useSessionContext();

    const [status, setStatus] = useState();
    const [material, setMaterial] = useState();
    const [formDirty, setFormDirty] = useState(0); 
    

    useEffect(() => {
        setStatus(props.filter.status);
        setMaterial(props.filter.material);
    }, [props.filter.status, props.filter.material]);
    

    function setFilter(){
        setFormDirty(0);
        setCurFilter({key:'CustomerReelTypesPage', filter:{customer:sessionCustomer.customer, material:material, status:status}, page:0, scroll:0});
        props.setFilterFx({customer:sessionCustomer.customer, material:material, status:status});
    }


    return (
        <Grid container spacing={2}>
            <Grid item xs={12} sm={4}>
                <CustomerReelTypesFilterMaterialList material={props.filter.material} setMaterialFx={setMaterial} setFormDirtyFx={setFormDirty} />
            </Grid>
            <Grid item xs={12} sm={4} sx={{textAlign:{xs:'center',sm:'left'}}}>
                <CustomerReelTypesFilterStatus status={props.filter.status} setStatusFx={setStatus} setFormDirtyFx={setFormDirty} />
            </Grid>
            <Grid item xs={12} sm={4} sx={{textAlign:{xs:'center', sm:'left'}}}>
                <Button type="button" variant="contained" disabled={formDirty===1?false:true} onClick={setFilter}>
                    <FilterListIcon />
                    <Typography sx={{ml:1}}>Filter</Typography>
                </Button>
            </Grid>            
        </Grid>
    );
}
